import { getDeviceId } from './license';

// anonymous onboarding funnel: random device id + step, each step sent once (open: once per day)
const API = `${process.env.REACT_APP_BACKEND_URL}/api/funnel`;
export function track(step) {
  const k = `giss_fn_${step}`, mark = step === 'open' ? new Date().toISOString().slice(0, 10) : '1';
  if (localStorage.getItem(k) === mark) return;
  const lang = localStorage.getItem('baustelle_app_lang') || '';
  fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ device_id: getDeviceId(), step, lang }) })
    .then((r) => { if (r.ok) localStorage.setItem(k, mark); })
    .catch(() => {});
}
